import { EvaluacionProductividadAdapter } from '../adapters/EvaluacionProductividad.adapter'

export default class CreateEvaluacionProductividadUseCase {
  #repository

  constructor(repository) {
    this.#repository = repository
  }

  async execute(evaluation, tipoEvaluacion) {
    try {
      const DEFAULT_FRECUENCIA_VALUE = 5

      const evaluationItems = await this.#repository.getEvaluationItems(tipoEvaluacion)
      evaluation.reactivos = evaluationItems.map((item) => ({
        realizados: '',
        idCatFrecuencia: DEFAULT_FRECUENCIA_VALUE,
        idIndicadorEvaluacion: item.fk_idCatIndicador,
      }))

      const actosRelevantes = await this.#repository.getActosRelevantes(tipoEvaluacion)
      evaluation.factoresMerito = actosRelevantes.map((actoRelevante) => ({
        cantidad: 0,
        descripcion: '',
        idActoRelevanteEvaluacion: actoRelevante.fk_idCatActosRelevantes,
      }))

      const dto = EvaluacionProductividadAdapter.toDto(evaluation)
      const id = await this.#repository.create(dto)

      return id
    } catch (error) {
      throw new Error(`Failed to execute CreateEvaluacionProductividadUsecase: ${error.message}`)
    }
  }
}
